import { render, staticRenderFns } from "./Single-Leave-Detail.vue?vue&type=template&id=67f81f43"
import script from "./Single-Leave-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Leave-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports